import { clsx } from 'clsx';
import { FC, LegacyRef, MouseEventHandler, forwardRef } from 'react';
import { Span } from '../Typography';
import styles from './styles.module.css';

export enum IconType {
  home = 'home',
  cart = 'cart',
  close = 'close',
  account = 'account',
  eye = 'eye',
  heart = 'heart',
  heartbordered = 'heartbordered',
  play = 'play',
  tick = 'tick',
  info = 'info',
  arrowDown = 'arrow-small-down',
  arrowUp = 'arrow-small-up',
  search = 'search',
  arrowLongLeft = 'arrow-long-left',
  arrowLongRight = 'arrow-long-right',
  arrowLongDown = 'arrow-long-down',
  burger = 'burger',
  arrowRight = 'arrow-right',
  manual = 'manual',
  xBold = 'x-bold',
  male = 'male',
  female = 'female',
  couple = 'couple',
  filter = 'filter',
  plus = 'plus',
  equal = 'equal',
  pen = 'pen',
  check = 'check',
}

export const Icon: FC<{
  className?: string;
  type?: IconType;
  testId?: string;
  onClick?: MouseEventHandler<HTMLSpanElement>;
}> = forwardRef(
  (
    { className = '', type = 'home', onClick, testId = 'icon', ...props },
    ref,
  ) => {
    return (
      <Span
        className={clsx(
          styles['icon'],
          styles[type],
          className,
          onClick && styles.pointer,
        )}
        onClick={onClick}
        data-testid={testId}
        {...props} // for correct work inside tooltip
        ref={ref as LegacyRef<HTMLElement>}
      />
    );
  },
);

Icon.displayName = 'Icon';
